module.exports = __webpack_public_path__ + "img/83e7c49.png";